// 追従バナー
document.addEventListener("DOMContentLoaded", function () {
  // 閉じるボタンとバナーを取得
  const closeButton = document.getElementById("closeButton");
  const fixedBanner = document.getElementById("fixedBanner");

  // バナーが存在する場合にのみ初期設定を行う
  if (fixedBanner) {
    fixedBanner.style.transition = "opacity 0.5s ease-out"; // フェードアウトアニメーション
  }

  // 閉じるボタンが存在し、かつバナーも存在する場合にクリックイベントを設定
  if (closeButton && fixedBanner) {
    closeButton.addEventListener("click", function () {
      // バナーをフェードアウトさせる
      fixedBanner.style.opacity = "0";
      // フェードアウト後に非表示にする
      setTimeout(function () {
        fixedBanner.style.display = "none";
      }, 500); // アニメーションと同じ時間で非表示
    });
  }
});
